// ─────────────────────────────────────────────
//  freeSince — how a bench provider's idle time is written.
//
//  Lifted out of TimelineSidePanels (718 lines, over the 500-line house rule):
//  both are pure time formatting with no React, and both already had their own
//  test file. TimelineSidePanels imports and re-exports them, so every existing
//  import keeps working.
// ─────────────────────────────────────────────

// The clock time a provider came out of a room: "3:15 PM".
//
// ⚠️ THIS IS THE PRIMARY FIGURE, AND THE DURATION IS SECONDARY, on purpose.
// A duration is only true while the page is live. This board can go stale --
// offline persistence will happily re-render the whole thing from cache with no
// callback to say so, which is why the rail carries LIVE / RECONNECTING at all.
// A frozen "1h 42m" keeps looking authoritative and is wrong by exactly however
// long the freeze lasted. A frozen "3:15 PM" is still correct.
export function freeAtLabel(sinceMs) {
  if (!Number.isFinite(sinceMs)) return null;
  const d = new Date(sinceMs);
  if (Number.isNaN(d.getTime())) return null;
  const h24 = d.getHours();
  const h = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h}:${String(d.getMinutes()).padStart(2, "0")} ${h24 < 12 ? "AM" : "PM"}`;
}

// "3h 12m" / "14m". Elapsed since the provider came out of a room.
export function elapsed(sinceMs, nowMs) {
  if (!Number.isFinite(sinceMs) || !Number.isFinite(nowMs)) return null;
  return elapsedLabel(Math.round((nowMs - sinceMs) / 60000));
}

// The same duration, from MINUTES rather than two timestamps — what a caller
// holding "now" and a shift end has. Split out of `elapsed` rather than written
// again beside it: two spellings of "1h 05m" is how one card starts disagreeing
// with the one below it about the same twenty minutes.
export function elapsedLabel(minutes) {
  if (!Number.isFinite(minutes)) return null;
  const min = Math.max(0, Math.round(minutes));
  if (min < 60) return `${min}m`;
  return `${Math.floor(min / 60)}h ${String(min % 60).padStart(2, "0")}m`;
}

